"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const modal_1 = require("components/cosmos/v2/modal");
const aiContent_1 = require("modules/app/services/datahub/aiContent");
const AIContentContext_1 = require("./AIContentContext");
const ContentForm_1 = __importDefault(require("./ContentForm"));
const ContentList_1 = __importDefault(require("./ContentList"));
const ContentLoadingData_1 = __importDefault(require("./ContentLoadingData"));
const AIContentModal_module_scss_1 = __importDefault(require("./AIContentModal.module.scss"));
var Steps;
(function (Steps) {
    Steps[Steps["FillForm"] = 1] = "FillForm";
    Steps[Steps["LoadingData"] = 2] = "LoadingData";
    Steps[Steps["ListModules"] = 3] = "ListModules";
})(Steps || (Steps = {}));
const AIContentModal = ({ onCloseModal }) => {
    const [step, setStep] = (0, react_1.useState)(Steps.FillForm);
    (0, react_1.useEffect)(() => {
        aiContent_1.DatahubAIContentService.sendOpen();
    }, []);
    const handleClose = () => {
        onCloseModal(false);
        let actionClose = aiContent_1.ActionClose.CloseByInsertingTheSubject;
        if (step === Steps.LoadingData) {
            actionClose = aiContent_1.ActionClose.CloseByWatingHotmartAI;
        }
        else if (step === Steps.ListModules) {
            actionClose = aiContent_1.ActionClose.CloseBySelectionItems;
        }
        aiContent_1.DatahubAIContentService.sendClose(actionClose);
    };
    const renderContentModal = () => {
        const stepComponents = {
            [Steps.FillForm]: ((0, jsx_runtime_1.jsx)(ContentForm_1.default, { onNextStep: () => setStep(Steps.LoadingData) })),
            [Steps.LoadingData]: ((0, jsx_runtime_1.jsx)(ContentLoadingData_1.default, { onNextStep: () => setStep(Steps.ListModules), onPreviousStep: () => setStep(Steps.FillForm) })),
            [Steps.ListModules]: ((0, jsx_runtime_1.jsx)(ContentList_1.default, { onNextStep: () => onCloseModal(true), onPreviousStep: () => setStep(Steps.FillForm) }))
        };
        return stepComponents[step];
    };
    return ((0, jsx_runtime_1.jsx)(AIContentContext_1.AIContentProvider, { children: (0, jsx_runtime_1.jsx)(modal_1.Modal, { show: true, className: AIContentModal_module_scss_1.default.container, onClose: handleClose, children: renderContentModal() }) }));
};
exports.default = AIContentModal;
